/**
 * May this user reach a thing?
 *
 * Checks the names given against BOTH what sign-in returned: the user's roles
 * (`roleUser`) and the permissions their roles carry (`permissionUser`). One pool,
 * because the question a screen asks is "may I show this", and whether the answer
 * arrives as a role or as a permission is the backend's business.
 *
 * That mirrors how the API gates these screens — `ability:SuperAdmin|manager,view-…`
 * ORs roles with permissions — so a menu and its endpoint agree by construction
 * instead of by coincidence.
 *
 * ⚠️ `permissionUser` holds ROLE permissions only (the backend builds it from
 * `permission_role`). A permission attached straight to a user authorises the API
 * but is invisible here, so anything that must show or hide UI has to be granted
 * to a role. A per-user permission belongs behind a server answer instead — see
 * the sign-on-behalf button, which binds to `may_sign` from the API.
 *
 * `allrequired` = every name must match; default is any-one-of.
 */
export default (roles, allrequired = false) => {
    let canEnter = false;

    const items = window.localStorage.getItem('roleUser');
    const roleUsers = JSON.parse(items);

    const permissionItems = window.localStorage.getItem('permissionUser');
    const permissionUsers = JSON.parse(permissionItems);

    // One pool: roles first (every existing caller passes exactly as before),
    // then the role-carried permissions.
    const granted = [
        ...(Array.isArray(roleUsers) ? roleUsers : []),
        ...(Array.isArray(permissionUsers) ? permissionUsers : []),
    ];

    // ກວດສອບກໍລະນີ userPermission || Permission ບໍ່ມີ Permission ລະບົບຈະ (Return False)...
    if (granted.length === 0 || !roles) {
        return canEnter;
    }

    // ກວດສອບຖ້າຫາກ Permission ທີ່ສົ່ງມາບໍ່ເເມ່ນ ລະບົບຈັ່ງເຮັດວຽກ Function ນີ້
    if (!Array.isArray(roles)) {
        canEnter = granted.includes(roles);
    }
    else {
        // Permission ຕ້ອງຖືກຕ້ອງທັງໝົດຈັ່ງເຮັດວຽກ Function ນີ້
        if (allrequired) {
            canEnter = roles.every(role => granted.includes(role));
        }
        // Permission ຖືກຕ້ອງອັນໃດອັນໜ່ິງກະເຮັດວຽກ Function ນີ້
        else {
            canEnter = granted.filter(role => {
                return roles.includes(role);
            }).length > 0;
        }
    }

   // ກໍລະນີ Permission ບໍ່ຖືກຕ້ອງອັນໃດເລີຍລະບົບຈະ (Return True) ອອກໄປ
    return canEnter;
}
